import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useLayers } from '../../hooks/index.js';
import { FAreaNode } from '../../types/index.js';

export type FAreaProps = GraphNodeProps<FAreaNode>;

export const FArea: React.FC<FAreaProps> = (props) => {
  const layers = useLayers();
  return (
    <farea
      {...props}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.FArea)}
    ></farea>
  );
};
